<div class="footer-with-buttons" [caLocalizationScope]="localizationScope">
  <button
    [title]="disableSaving ? ('createReportDisabled' | caLocalize) : ''"
    class="btn btn-primary me-2"
    data-automation-id="submit-button"
    title="{{ createReportTitle | caLocalize }}"
    [disabled]="disableSaving"
    (click)="onCreateReport()"
  >
    {{ createReportTitle | caLocalize }}
  </button>
  @if (isConfigurable) {
  <a
    data-automation-id="preview-and-customize"
    class="btn btn-primary ms-1"
    target="_blank"
    [href]="getExportReportLink()"
    (click)="onPreviewAndCustomizeClick()"
  >
    {{ 'previewAndCustomize' | caLocalize }}
  </a>
  }
  <button
    class="btn btn-secondary"
    [ngClass]="{ 'ms-0': isConfigurable }"
    data-automation-id="cancel-button"
    title="{{ 'cancel' | caLocalize }}"
    (click)="cancel()"
  >
    {{ 'cancel' | caLocalize }}
  </button>
</div>
